import { sortBy } from "lodash";
import { deepFreeze } from "../../../util/misc.js";

export const SET_NOTIFICATION = (
  state,
  { notification, oldIndex, newIndex }
) => {
  if (!notification.type) {
    console.error("Invalid notification type", notification);
    return;
  }
  if (oldIndex >= 0) {
    state.notifications.splice(oldIndex, 1);
  }
  if (newIndex >= 0) {
    state.notifications.splice(newIndex, 0, deepFreeze(notification));
  } else {
    state.notifications.push(deepFreeze(notification));
    state.notifications = sortBy(state.notifications, "timestamp");
  }
};

export const REMOVE_NOTIFICATION = (state, index) => {
  state.notifications.splice(index, 1);
};

export const CLEAR_NOTIFICATIONS = (state) => {
  state.notifications = [];
};

export const SET_NOTIFICATION_COUNTS = (state, counts) => {
  state.notificationCounts = {
    total: counts?.total ?? 0,
    undone: counts?.undone ?? 0,
    unread: counts?.unread ?? 0,
  };
};

export const CLEAR_NOTIFICATION_COUNTS = (state) => {
  state.notificationCounts = { total: 0, undone: 0, unread: 0 };
};

export const SET_REMINDER = (state, { reminder, oldIndex, newIndex }) => {
  if (oldIndex >= 0) {
    state.reminders.splice(oldIndex, 1);
  }
  state.reminders.splice(newIndex, 0, deepFreeze(reminder));
};

export const REMOVE_REMINDER = (state, index) => {
  state.reminders.splice(index, 1);
};

export const CLEAR_REMINDERS = (state) => {
  state.reminders = [];
};
